import { VehicleOutput } from '@allocab/allocab-driver-service-types';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../services/datastore/queryKeys';
import { driverApi } from '../services/network/Api';

const fetchVehicle = (id: string) => driverApi.get<void, VehicleOutput>(`/v1/vehicle/${id}`);

export const useFetchVehicle = (id: string) => useQuery(queryKeys.user.fetchVehicle(id), () => fetchVehicle(id));
